/**
 * The value of the downlink property of the NetworkInformation interface
 * below which indicates a slow connection.
 */
export const SLOW_NETWORK_DOWNLINK = 2;
